import React, { useEffect, useState } from 'react';
import moment from 'moment';
import './ProgressCardComponent.styles.scss';
import { Popover, Steps } from 'antd';

const { Step } = Steps;
const ProgressCardComponent = ({ objective, status, platform, created, campaignid }) => {
  const [stepOrder, setStepOrder] = useState(['review', 'published', 'active', 'completed']);
  const [current, setCurrent] = useState(0);
  useEffect(() =>{
    // @note: set progress status
    // renderStatus()
    setCurrent(stepOrder.indexOf(status || 'review') || 0);
    console.log('current', current);
  }, []);
  // const renderStatus = () =>{
  //     stepOrder.map((st,index)=>{
  //         if(current < index){
  //             return <Step key={st} status="finish" title={st} />
  //         }

  //         else if(current < index){
  //             return <Step key={st} status="wait" title={st} />
  //         }

  //         else{
  //             return <Step key={st} status="progress" title={st} />
  //         }
  //     })
  // }

  // const customDot = (dot, { status, index }) => (
  //     <Popover
  //       content={
  //         <span>
  //           step {index} status: {status}
  //         </span>
  //       }
  //     >
  //       {dot}
  //     </Popover>
  // );
  return (
    <div className="over_progress common_card p-3">
      <div className="over_progress_top pb-1">
        <ul className="over_progress_top_list">
          <li>
            <p>Platform</p>
            <h6>{platform || 'N/A'}</h6>
          </li>
          <li>
            <p>Objective</p>
            <h6>{objective || 'N/A'}</h6>
          </li>
          <li>
            <p>Status</p>
            <h6>{status || 'N/A'}</h6>
          </li>
        </ul>
        <div className="over_progress_top_addon">
                    Campaign ID<span>{campaignid || 'N/A'}</span>,
        </div>
        <div className="clearfix"></div>
      </div>
      <div className="over_progress_bar py-2">
        <Steps
          type="navigation"
          size="small"
          current={current}
          // onChange={this.onChange}
          className="site-navigation-steps"
          // progressDot={customDot}
        >
          {/* {renderStatus()} */}
          {
            stepOrder.map((st, index)=>{
              if (current > index) {
                return <Step key={st}
                  status="finish"
                  title={st} />;
              } else if (current < index) {
                return <Step key={st}
                  status="wait"
                  title={st} />;
              } else {
                return <Step key={st}
                  status="process"
                  title={st} />;
              }
            })
          }
          {/* <Step title="In Review" />
                    <Step title="Published" />
                    <Step title="Active" />
                    <Step title="Closed" /> */}
        </Steps>
      </div>
      <div className="over_progress_bottom">
        <div className="over_progress_bottom_left">
                    Created: <strong>{moment(created).format('Do, MMM YYYY hh:mm a')}</strong>
        </div>
      </div>
    </div>
  );
};

export default ProgressCardComponent;
